var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 14.25H4.598a.698.698 0 01-.698-.697V4.95a.45.45 0 10-.9 0v8.602a1.605 1.605 0 001.598 1.598H13.2a.45.45 0 000-.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.563 6.48l-.51-1.56a.48.48 0 00-.226-.262.457.457 0 00-.345 0l-1.567.495a.45.45 0 00-.285.57.45.45 0 00.57.277l.51-.172-2.25 3.397-2.25-1.672a.472.472 0 00-.615.135l-2.513 3.615a.443.443 0 00.113.622c.075.05.164.076.255.075a.434.434 0 00.367-.195l2.25-3.247 2.25 1.672a.454.454 0 00.353.082.411.411 0 00.293-.194l2.587-3.9.172.532a.457.457 0 00.428.308.3.3 0 00.143 0 .436.436 0 00.27-.578z"
  })));
}
export default SvgDashboard;